import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

export default function(
  toggle: boolean,
  id: string = null,
): IToggleDeleteReservationModal {
  return { id, toggle, type: ReservationModalActions.ToggleDeleteModal }
}

export interface IToggleDeleteReservationModal
  extends Action<ReservationModalActions.ToggleDeleteModal> {
  toggle: boolean
  id?: string
}
